var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBells(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00342 0V16H13.9904V0L2.00342 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4286 13.0001H12.9915V5.99999C12.9915 3.42813 11.053 1.31096 8.55881 1.03127V0.56252C8.55881 0.251543 8.30754 0 7.9969 0C7.68634 0 7.43499 0.251543 7.43499 0.56252V1.03127C4.94084 1.31096 3.00232 3.42813 3.00232 5.99999V13.0001H2.56533C2.25469 13.0001 2.00342 13.2516 2.00342 13.5625C2.00342 13.8735 2.25469 14.125 2.56533 14.125H6.87318V14.8751C6.87318 15.4969 7.3757 16 7.9969 16C8.61811 16 9.12072 15.4969 9.12072 14.8751V14.125H13.4286C13.7391 14.125 13.9904 13.8735 13.9904 13.5625C13.9904 13.2516 13.7391 13.0001 13.4286 13.0001ZM11.8677 13.0001H4.1261V5.99999C4.1261 3.85942 5.85862 2.12502 7.99686 2.12502C10.1352 2.12502 11.8677 3.85942 11.8677 5.99999V13.0001Z",
    fill: "black",
    fillOpacity: 0.65
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBells);
export default __webpack_public_path__ + "static/media/bells.be735e90.svg";
export { ForwardRef as ReactComponent };